import { render, staticRenderFns } from "./finished.vue?vue&type=template&id=3db477ae"
import script from "./finished.vue?vue&type=script&lang=js"
export * from "./finished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports